import { Injectable } from '@angular/core';
import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader';
import { FBX } from '../models/fbx';

import { BehaviorSubject } from 'rxjs';


@Injectable({
    providedIn: 'root'
})
export class fbxService {
    public loader = new FBXLoader();
    public total = 0;
    public numLoaded = 0;
    public data: Array<FBX> = null;
    public modelsLoaded = new BehaviorSubject(false);

    constructor() { }


    public setModelsLoaded(loaded: boolean): void {
        this.modelsLoaded.next(loaded);
    }

    public batchLoadFBX(fbxData: Array<FBX>): void {
        this.data = fbxData;
        this.setModelsLoaded(false);
        this.total = fbxData.length;
        this.numLoaded = 0;
        fbxData.forEach(fbx => {
            // console.log("DO IT", fbx);
            this.loadFBX(fbx, false);
        });
    }

    public loadFBX(fbx: FBX, bSingle: boolean = true): void {
        // console.log('fbx.path', fbx.path);
        this.loader.load(fbx.path, (object) => {
            fbx.fbx = object;
            fbx.loaded = true;
            // console.log("DID IT", fbx);
            object.traverse(function (child: any) {
                if (child.isMesh) {
                    child.castShadow = (fbx.shadow) ? fbx.shadow : false;
                    child.receiveShadow = true;
                }
            });
            if (!bSingle) {
                this.fbxLoaded()
            }

        });

    }

    public fbxLoaded(): void {
        this.numLoaded++;
        if (this.numLoaded >= this.total) {
            this.setModelsLoaded(true);
        }
    }
}
